import Backbone from "backbone";
import $ from "jquery";

const navigationHelper = {
  setUpUrl: (url) => {
    $("nav .nav li .nav-link").removeClass("active");
    $("nav .nav li.nav-dropdown").removeClass("open");
    if (url === "default") {
      $('nav .nav li:has(a[href="#/"])').addClass("open");
      $('nav .nav a[href="#/"]').addClass("active");
    } else {
      $('nav .nav li:has(a[href*="' + url.split("/")[1] + '"])').addClass(
        "open",
      );
      $('nav .nav a[href*="' + url.split("/")[1] + '"]').addClass("active");
    }
  },

  resizeBroadcast: () => {
    let timesRun = 0;
    const interval = setInterval(() => {
      timesRun += 1;
      if (timesRun === 5) {
        clearInterval(interval);
      }
      window.dispatchEvent(new Event("resize"));
    }, 62.5);
  },

  initNavEvents: function () {
    $.navigation = $("nav > ul.nav");
    const url = location.hash;
    const that = this;

    url !== "" && url !== "#/" ? this.setUpUrl(url) : this.setUpUrl("default");

    $(document).on(
      "click",
      '.nav a[href!="#"], .affect-nav-link',
      function (e) {
        const target = $(e.currentTarget);
        if (
          $(this).parent().parent().hasClass("nav-tabs") ||
          $(this).parent().parent().hasClass("nav-pills")
        ) {
          e.preventDefault();
        } else if ($(this).attr("target") === "_top") {
          e.preventDefault();
          window.location = target.attr("href");
        } else if ($(this).attr("target") === "_blank") {
          e.preventDefault();
          window.open(target.attr("href"));
        } else {
          e.preventDefault();
          const href = target.attr("href");
          const oldUrl = window.location.href;

          that.setUpUrl(href);
          window.location.href = href;

          if (href?.startsWith("#")) {
            setTimeout(() => {
              Backbone.history.fragment = null;
              Backbone.history.loadUrl(href.replace(/^#\/?/, ""));
            }, 0);
          }
        }
      },
    );

    // Dropdown Menu
    $.navigation.on("click", "a", function (e) {
      if ($.ajaxLoad) {
        e.preventDefault();
      }

      if ($(this).hasClass("nav-dropdown-toggle")) {
        $(this).parent().toggleClass("open");
        this.resizeBroadcast();
      }

      // hide the sidebar menu on mobile after click
      if ($(".mobile-sidebar-toggler").is(":visible")) {
        $(".mobile-sidebar-toggler").click();
      }
    });

    /* ---------- Main Menu Open/Close, Min/Full ---------- */
    $(".sidebar-toggler").click(() => {
      $("body").toggleClass("sidebar-hidden");
      that.resizeBroadcast();
    });

    $(".sidebar-minimizer").click(() => {
      $("body").toggleClass("sidebar-minimized");
      that.resizeBroadcast();
    });

    $(".brand-minimizer").click(() => {
      $("body").toggleClass("brand-minimized");
    });

    $(".aside-menu-toggler").click(() => {
      $("body").toggleClass("aside-menu-hidden");
      that.resizeBroadcast();
    });

    $(".mobile-sidebar-toggler").click(() => {
      $("body").toggleClass("sidebar-mobile-show");
      that.resizeBroadcast();
    });

    $(".sidebar-close").click(() => {
      $("body")
        .toggleClass("sidebar-opened")
        .parent()
        .toggleClass("sidebar-opened");
    });
    /* ---------- Disable moving to top ---------- */
    $('a[href="#"][data-top!=true]').click((e) => {
      e.preventDefault();
    });

    // handle premium cta click
    $(document).on("click", ".trigger-premium-info", (e) => {
      e.preventDefault();
      Backbone.trigger("overlays:premium");
    });

    // handle advanced editing features cta click
    $(document).on("click", ".trigger-advanced-editing-features-info", (e) => {
      e.preventDefault();
      Backbone.trigger("overlays:advancedEditingFeatures");
    });

    // handle clicks outside of popovers
    // dismiss the popover when clicking outside of the popover body
    $(document).on("click", (e) => {
      if (
        $(e.target).closest('[data-bs-toggle="popover"]').length === 0 &&
        $(e.target).closest(".popover.show").length === 0
      ) {
        // Bootstrap 5 popover API - get all initialized popovers and hide them
        $('[data-bs-toggle="popover"]').each(function () {
          const popoverInstance = window.bootstrap?.Popover?.getInstance(this);
          if (popoverInstance) {
            popoverInstance.hide();
          }
        });
      }
    });
  },
};

export default navigationHelper;
